import { RescheduleRestrictionLevel } from './checkRescheduleRestrictions';

export type CanOfferRescheduleAllParams = {
  /**
   * The reschedule-restrictions verdict for the whole set being moved, or
   * `null` when the check could not be answered (timeout/5xx/unreachable).
   */
  siblingLevel: RescheduleRestrictionLevel | null;
  /**
   * How many separately-reschedulable items the day collection holds. The
   * checkbox is only meaningful when there is something else to move.
   */
  separateItemCount: number;
};

/**
 * Whether the drag-confirmation dialog may offer "reschedule all other
 * services for this customer".
 *
 * The dialog moves every appointment in the day collection in one go
 * (`reschedule.ts` runs the saves with `parallel`), but the backend re-checks
 * each one on the write and rejects a `BLOCKED` appointment with a 422. A
 * partner who dragged an unrestricted appointment - a pay-at-venue one, say,
 * which is exempt server-side - would otherwise tick the box and have the
 * restricted sibling silently fail while the rest committed (THY-2335).
 *
 * So the offer is withheld unless the whole set is known to be unrestricted.
 * `null` withholds it too: without a verdict we cannot promise the siblings
 * will move. That is not a fail-closed on the reschedule itself - the dragged
 * appointment still moves normally, the partner just moves the others
 * individually - so it does not block a reschedule the restriction check gave
 * no verdict on, which the check's fail-open rule exists to prevent.
 */
export function canOfferRescheduleAll({
  siblingLevel,
  separateItemCount,
}: CanOfferRescheduleAllParams): boolean {
  if (separateItemCount <= 1) {
    return false;
  }

  return siblingLevel === 'NONE';
}
